// extracted by mini-css-extract-plugin
export default {"container":"xl-z","blurb":"yl-z","links":"zl-z"};